function MGContainer({ children }) {
  return <div className="container">{children}</div>;
}

MGContainer.propTypes = {};

export default MGContainer;
